import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	tabBarWrapper: {
		display: "flex",
		justifyContent: "flex-end",
		marginBottom: theme.spacing(1)
	},
	tabBar: {
		display: "inline-flex",
		flexDirection: "row",
		alignItems: "center",
		gap: "5px",
		padding: "2px",
		border: `1.6px solid ${colors.purple[500]}`,
		borderRadius: 10,
		backgroundColor: colors.gray[0]
	},
	tab: {
		display: "flex",
		alignItems: "center",
		gap: "5px",
		padding: "4px 9px",
		borderRadius: 7,
		cursor: "pointer",
		color: colors.gray[400],
		fontSize: "0.75rem",
		fontWeight: 700,
		userSelect: "none" as const,
		lineHeight: 1.6,
		whiteSpace: "nowrap" as const,
		transition: "background 0.12s ease, color 0.12s ease"
	},
	tabActive: {
		backgroundColor: colors.purple[500],
		color: `${colors.gray[0]} !important`
	},
	tabDisabledWrapper: {
		cursor: "not-allowed",
		opacity: 0.45
	},
	tabDisabledContent: {
		pointerEvents: "none" as const,
		display: "flex",
		alignItems: "center",
		gap: "5px"
	},
	infoText: {
		display: "flex",
		alignItems: "flex-start",
		gap: theme.spacing(0.5),
		marginTop: theme.spacing(1),
		fontSize: "0.75rem",
		color: colors.gray[700],
		borderTop: `1px dashed ${colors.gray[200]}`,
		paddingTop: theme.spacing(1)
	},
	primaryText: {
		cursor: "pointer",
		fontWeight: 700,
		"&:hover": {
			textDecoration: "underline"
		}
	},
	infoIcon: {
		fontSize: "0.875rem !important",
		marginTop: 1,
		flexShrink: 0
	}
}))

export default useStyles
